export const INTEGRATIONS = {
    DISABLED: 'DISABLED',
    CAF: 'CAF'
};
